'use client';

import { SvgChevrondown } from '@common/icon';
import { cn } from '@core/utils';
import { useState } from 'react';

import { CustomLink } from '@/app/_components/CustomLink';
import { DONATION_ROUTES } from '@/constants';

import type { HometownBusinessSearchParams } from '../page';

interface SideFilterProps {
  institutionOptions: {
    label: string;
    value: number;
    isNew?: boolean;
  }[];
  institutionId?: number;
  searchParams: HometownBusinessSearchParams;
}

export const SideFilter = ({
  institutionOptions,
  institutionId,
  searchParams,
}: SideFilterProps) => {
  const [institutionExpanded, setInstitutionExpanded] = useState(true);

  return (
    <aside className={cn('shrink-0 basis-160', 'mobile-tablet:hidden')}>
      {/** 지자체 필터 */}
      <div className="flex flex-col gap-16">
        <button
          type="button"
          onClick={() => setInstitutionExpanded(!institutionExpanded)}
          aria-expanded={institutionExpanded}
          className="flex w-full items-center justify-between"
        >
          <p className="font-700 text-Gray-900 typo-body2">지자체</p>
          <SvgChevrondown
            className={cn('size-16 text-Gray-black duration-300', {
              'rotate-180': institutionExpanded,
            })}
          />
        </button>
        <div
          className={cn(
            'grid transition-all duration-300 ease-in-out',
            institutionExpanded ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]',
          )}
        >
          <ul className="flex flex-col gap-12 overflow-hidden px-12">
            {institutionOptions.map(({ label, value, isNew }) => {
              const isActive =
                institutionId === value ||
                (institutionId === undefined && value === 0);

              return (
                <li key={value} className="flex items-center gap-4">
                  <CustomLink
                    href={DONATION_ROUTES.HOMETOWNS_BUSINESS.withSearchParams({
                      searchParams: {
                        ...searchParams,
                        institutionId: value ? value : undefined,
                      },
                    })}
                    className={cn(
                      'font-500 text-Gray-550 duration-150 typo-body3',
                      {
                        'font-600 text-Gray-900': isActive,
                        'hover:text-Gray-700': !isActive,
                      },
                    )}
                  >
                    {label}
                  </CustomLink>
                  {isNew && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <circle cx="7.99805" cy="8" r="8" fill="#F5511D" />
                      <path
                        d="M10.37 5V11H9.41L6.56 6.9H6.51V11H5.44V5H6.42L9.24 9.1H9.3V5H10.37Z"
                        fill="white"
                      />
                    </svg>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </aside>
  );
};
